import { standardDateFormat } from "../../../../helpers/date"
import { Amalgam, Medical, Pharmaceutical } from "../types"

export const getItemStatus = (item: Amalgam | Medical | Pharmaceutical) => {
  const processedDate = item.hasOwnProperty('processed_date')
    ? (item as Amalgam | Pharmaceutical).processed_date
    : (item as Medical).destroyed_date

  if (processedDate !== null) {
    return 'Processed'
  } else if (item.used_date !== null) {
    return 'Used'
  } else {
    return 'In Use'
  }
}

export const getProcessedDate = (item: Amalgam | Medical | Pharmaceutical) => {
  const processedDate = item.hasOwnProperty('processed_date')
    ? (item as Amalgam | Pharmaceutical).processed_date
    : (item as Medical).destroyed_date

  return standardDateFormat(processedDate)
}
